import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { simCards } from '../data/simCards';
import './Home.css';

const Home: React.FC = () => {
  const featuredProducts = simCards.slice(0, 3);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Stay Connected Worldwide</h1>
            <p>Premium international SIM cards for seamless global connectivity. No roaming charges, instant activation, and reliable coverage in 150+ countries.</p>
            <div className="hero-buttons">
              <Link to="/products" className="cta-button primary">Shop SIM Cards</Link>
              <Link to="/products" className="cta-button secondary">View Coverage</Link>
            </div>
          </div>
          <div className="hero-image">
            <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop" alt="Global connectivity" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2>Why Choose SimConnect?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Global Coverage</h3>
              <p>Stay connected in 150+ countries with our premium network partnerships</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Instant Activation</h3>
              <p>Get online immediately with our quick setup and activation process</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>No Hidden Fees</h3>
              <p>Transparent pricing with no roaming charges or surprise bills</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure & Reliable</h3>
              <p>Enterprise-grade security with 99.9% network uptime guarantee</p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="featured-products">
        <div className="container">
          <div className="section-header">
            <h2>Popular SIM Cards</h2>
            <Link to="/products" className="view-all-link">View All Products →</Link>
          </div>
          <div className="products-grid">
            {featuredProducts.map(simCard => (
              <ProductCard key={simCard.id} simCard={simCard} />
            ))}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="trust">
        <div className="container">
          <div className="trust-content">
            <h2>Trusted by 50,000+ Travelers</h2>
            <div className="trust-stats">
              <div className="stat">
                <div className="stat-number">150+</div>
                <div className="stat-label">Countries</div>
              </div>
              <div className="stat">
                <div className="stat-number">50K+</div>
                <div className="stat-label">Happy Customers</div>
              </div>
              <div className="stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Uptime</div>
              </div>
              <div className="stat">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Support</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
